import { isKidsProfile } from '../../../utils/user';
import { getUserInfo } from '../../../utils/user';

export function extractQuests(data = [], type) {
    return data
        ? data
              .map(({ attributes = [] }) => {
                  const attrMap = Object.fromEntries(attributes?.map(({ key, value }) => [key, value]));

                  if (attrMap.quest_type !== type) return null;

                  const quest_id = attrMap.quest_id;
                  const quest_order = Number(attrMap.quest_order);
                  const quest_points = Number(type === 'Earn' ? attrMap.quest_points : attrMap.quest_target_points);

                  if (!quest_id || isNaN(quest_order) || isNaN(quest_points)) return null;

                  return { quest_id, quest_order, quest_points, quest_type: attrMap.quest_type };
              })
              .filter(Boolean)
              .sort((a, b) => a.quest_order - b.quest_order)
        : [];
}

export function getQuestsByActivity(quests = [], gamificationConfigs) {
    const configQuests = gamificationConfigs.quests ?? {};
    const isKid: boolean = isKidsProfile();
    const userOperator = getUserInfo('operator');

    return quests
        .map(({ quest_id, quest_points, quest_type }) => {
            const questConfig = configQuests[quest_id];
            if (!questConfig) return null;

            const {
                questTitle,
                questDescription,
                questCTAKey,
                wcpLink,
                isEnabledForAdults,
                isEnabledForKids,
                allowedOperators = [],
            } = questConfig;
            const isAllowed = allowedOperators.map((op) => op.toLowerCase()).includes(userOperator.toLowerCase());

            if (isKid && !isEnabledForKids) return null;
            if (!isKid && !isEnabledForAdults) return null;
            if (!isAllowed) return null;

            return {
                id: quest_id,
                title: questTitle,
                description: questDescription,
                ctaLabel: questCTAKey,
                redirect: wcpLink,
                points: quest_points,
                type: quest_type,
                questTypeId: quest_id,
                isEnabledForAdults,
                isEnabledForKids,
            };
        })
        .filter(Boolean);
}
